// デフアカデミー先生のエンティティ
export class DaTeacher {
  // ユーザーID DB型(*fk)
  public user_id?: string;
  // 紹介ページコンテンツ DB型(LONGTEXT)
  public contents?: string;
  // 定員 DB型(INT)
  public limit_count?: number;
  // 自動確定期限(不使用) DB型(DATETIME)
  public limit_date?: Date;
  // 期間設定可能 DB型(*flg)
  public is_time_flex?: boolean;
  // 自動確定期限 DB型(INT)
  public limit_days_befor?: number;
  // 予約ページ表示 DB型(*flg)
  public is_show_reservation_page?: boolean;
  // 運営表示 DB型(*flg)
  public is_shown_admin_page?: boolean;
  static fromDB(record: { [column: string]: any; [column: number]: any }): DaTeacher {
    const entity = new DaTeacher();
    entity.user_id = record['user_id'];
    entity.contents = record['contents'];
    entity.limit_count = record['limit_count'];
    entity.limit_date = record['limit_date'];
    entity.is_time_flex = record['is_time_flex'];
    entity.limit_days_befor = record['limit_days_befor'];
    entity.is_show_reservation_page = record['is_show_reservation_page'];
    entity.is_shown_admin_page = record['is_shown_admin_page'];
    return entity;
  }
  static getTypeFitEntity(value: any): DaTeacher {
    const entity = new DaTeacher();
    entity.user_id = value.user_id;
    entity.contents = value.contents;
    entity.limit_count = value.limit_count;
    entity.limit_date = value.limit_date;
    entity.is_time_flex = value.is_time_flex;
    entity.limit_days_befor = value.limit_days_befor;
    entity.is_show_reservation_page = value.is_show_reservation_page;
    entity.is_shown_admin_page = value.is_shown_admin_page;
    return entity;
  }
}
